export const NONE = Object.freeze({})
export const VISIBLE = Object.freeze({ visible: '' })
export const INVISIBLE = Object.freeze({ invisible: '' })
export const OPENED = Object.freeze({ opened: '' })
